import { formatDate } from 'utils/date';

import { GridValueFormatterParams } from '@mui/x-data-grid-pro';

export const dateFormatter = (
  params: GridValueFormatterParams
): string | undefined => {
  const { value } = params;
  if (!value) return;

  return formatDate(value);
};
